export default __webpack_public_path__ + "static/media/carousel1.136391ba.jpg";